import { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: string;
}>;

export default function TableHeaderCell({ children, className }: Props) {
  return (
    <th
      scope="col"
      style={{ hyphens: "auto", hyphenateLimitChars: "6 3 3 " }}
      className={className}
    >
      {children}
    </th>
  );
}
